<template>
  <div
    class="alert max-w-sm text-wrap flex items-center justify-between rounded-xl bg-brand-surface-hover backdrop-blur-3xl border-0"
  >
    <div
      class="flex w-9 h-9 justify-center items-center gap-2.5 shrink-0 text-basics-primary"
      :class="{
        'rounded-[10px] bg-basics-accent-red': type === 'error' && !icon,
        'rounded-[10px] bg-basics-accent-green': type === 'success' && !icon,
        'rounded-[10px] bg-brand-primary': type === 'info' && !icon,
      }"
    >
      <Icon
        v-if="icon"
        :icon="icon"
        class="inline text-4xl"
        :class="{
          'text-basics-accent-red': type === 'error',
          'text-basics-accent-green': type === 'success',
        }"
      />
      <ErrorIcon v-else-if="type === 'error'" />
      <Icon
        v-else-if="type === 'success'"
        icon="mdi:check"
        class="inline text-2xl"
      />
      <Icon
        v-else-if="type === 'info'"
        icon="mdi:info-outline"
        class="inline text-2xl"
      />
    </div>
    <div
      class="flex-col justify-center items-start inline-flex text-left w-full"
    >
      <div
        v-if="title"
        class="self-stretch text-white text-sm font-semibold font-sans leading-tight"
      >
        {{ title }}
      </div>
      <div
        class="self-stretch text-white/80 text-[13px] font-medium font-sans leading-tight"
        :class="{ 'text-sm font-semibold': !title }"
      >
        {{ message }}
      </div>
      <div v-if="action" class="mt-2">
        <ButtonV2
          size="xs"
          variant="primary"
          class="text-text hover:text-on-brand px-3 gap-2"
          @click="onActionClick"
        >
          <Icon icon="mdi:restart" class="text-sm" />
          <span class="text-sm">{{ action.label }}</span>
        </ButtonV2>
      </div>
    </div>
    <ButtonV2
      v-if="!persistent || closable"
      size="xs"
      variant="ghost"
      aria-label="Close"
      class="!p-2"
      @click="emit('close')"
    >
      <Icon icon="mdi:close" class="text-basics-primary" />
    </ButtonV2>
  </div>
</template>
<script setup lang="ts">
import { Icon } from "@iconify/vue";
import ErrorIcon from "./error-icon.vue";
import ButtonV2 from "../button/button-v2.vue";

const props = defineProps<{
  type: "info" | "success" | "error";
  title?: string;
  message: string;
  persistent: boolean;
  closable?: boolean;
  icon?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}>();

const emit = defineEmits<{
  close: [];
}>();

const onActionClick = () => {
  props.action?.onClick();
  emit("close");
};
</script>
